import { useState, useEffect } from 'react';
import { makeGetCall } from '../utils/helper';

/**
 * Custom hook to fetch and cache site options
 * @returns {Object} { siteOptions, loading, error, refetch }
 */
export const useSites = () => {
  const [siteOptions, setSiteOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSites = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await makeGetCall('/sites');
      
      if (response?.data?.success) {
        setSiteOptions(response.data.data || []);
      } else {
        throw new Error(response?.data?.message || 'Failed to fetch sites');
      }
    } catch (err) {
      console.error('Error fetching sites:', err);
      setError(err.message || 'Failed to fetch sites');
      
      // Fallback to hardcoded options if API fails (using your actual data format)
      setSiteOptions([
        { label: 'Somajiguda', value: 'smj' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSites();
  }, []);

  const refetch = () => {
    fetchSites();
  };

  return {
    siteOptions,
    loading,
    error,
    refetch
  };
};